document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('confirm_popup')) return;

    const popup = document.getElementById('confirm_popup');
    const checkbox = document.getElementById('confirm_checkbox');
    const dropdownText = document.querySelector('.product-form .custom-select .text-start');
    const phoneTitle = document.getElementById('phone-title');
    const atcButton = document.getElementById('atc_button');
    const dynamicCheckoutBtns = document.querySelectorAll('accelerated-checkout-button');

    if (checkbox == null || atcButton == null) return;

    updateCartButtons();

    checkbox.addEventListener('change', () => {
        updateCartButtons();
    });

    document.addEventListener('on:variant:change', function (event) {
        checkbox.checked = false;
        popup.classList.add('active');
        if (dropdownText && phoneTitle) {
            phoneTitle.innerHTML = dropdownText.innerHTML;
        }
        updateCartButtons();
    });

    function updateCartButtons() {
        if (checkbox.checked) {
            atcButton.disabled = false;
            dynamicCheckoutBtns.forEach(btn => {
                btn.disabled = false;
            });
        } else {
            atcButton.disabled = true;
            dynamicCheckoutBtns.forEach(btn => {
                btn.disabled = true;
            });
        }
    }
});